import { ISdFilterDef } from "./BaseColumnTypes";

export class ColumnFilterBuilder {
  filterOptions: ISdFilterDef;

  setFilterOptions = (filterOptions: ISdFilterDef) => (this.filterOptions = filterOptions);
}
